/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import ProgressBar from 'components/shared/progressbar/progressbar';
import Question from 'components/content/shared/questionset/shared/question/question_container';
import Answer from 'components/content/shared/questionset/shared/answer/answer_container';
// import QuestionResult from 'components/shared/questionset/shared/result/result_container';
// import RewardsMessage from 'components/shared/questionset/shared/rewards/rewards_container';
import UserMessage from 'components/shared/usermessage/usermessage';
import RewardsFeedback from 'components/shared/rewardsfeedback/rewardsfeedback_container';
import Skip from 'components/shared/skip/skip_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/text1/text1_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:true});


/* ========== ~~~~~~~~~~ TEXT 1 SET ~~~~~~~~~~ ========== */
const Text1Set = (passedProps) => {
    let props = passedProps.data;
    const resultClass = props.frameStatus[props.frame]['state'];
    sheet.update(props.hasRewardsComponent);
    // resultClass = props.frameStatus[props.frame].includes('rewards') ? 'rewards' : resultClass;
    return(
        <div className={`${sheet.classes.typeset} type-${props.frameData.question.type} parentContentType-${passedProps.contentType} answeramount-${props.frameData.answers.length} ${resultClass}`}>
            {props.showFrameForXSeconds != null ? <ProgressBar type={`frame`} duration={props.showFrameForXSeconds} fillingDelay={0} direction={`leftToRight`} isActive={props.showFrameForXSeconds != null} shouldKillItself={resultClass === 'clicked'}/> : null}
            <Question contentId={props.contentId} frameData={props.frameData} />
            <div className={`${sheet.classes.answerset} answerset answeramount-${props.frameData.answers.length}`}>
                <ul>
                    {props.frameData.answers.map(answer => <Answer type={props.frameData.question.type} answer={answer} predictionPercentage={passedProps.percentageAnsweredData[answer.id]} barCoefficient={passedProps.barCoefficient} contentId={props.contentId} frame={props.frame} isCorrectAnswer={answer.isCorrect} currentQuestionnaire={props.currentQuestionnaire} />)}
                </ul>
                {props.frameData.answers.map(answer => !!props.frameStatus[props.frame].options[answer.id].isCorrect ? <span className={`showcorrectanswer`}><span className={`icon`}/><span className={`text`}>{answer.text}</span></span> : null )}
            </div>
            <div className={`${sheet.classes.resultelements} resultelements`}>
                {/*uestionResult component handles logic related to calculating and awarding points / triggering or skipping the rewards phase and advancing the result phase*/}
                {/*<QuestionResult contentId={props.contentId} frame={props.frame} />*/}
                <UserMessage hasRewardsComponent={passedProps.hasRewardsComponent}>
                    <RewardsFeedback contentId={passedProps.data.contentId} frame={props.frame}/>
                </UserMessage>
                <ProgressBar type={`result`} duration={props.showResultForXSeconds} direction={`leftToRight`} fillingDelay={2400} isActive={resultClass === 'result'} shouldKillItself={false} />
            </div>
            {/*<RewardsMessage contentId={passedProps.data.contentId} frame={props.frame} />*/}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Text1Set;
